import React from 'react';
import './IconButton.css';
import '../button.css';

const IconButton = (props) => {
    return (
        <div className='icon-btn bwwp-btn' style={{ backgroundColor: props.color }} onClick={ props.onClick }>
            <div className='icon-btn-icon'>
                <span className="fa-stack fa-sm">
                    <i className={"fa fa-inverse fa-stack-2x " + props.icon } aria-hidden="true"></i>
                </span>
            </div>
            <div className='icon-btn-label'>{props.label}</div>
        </div>
    )
}

export default IconButton;